module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-usuario-item"
  }, [_c('div', {
    staticClass: "imagem u-img-rounded"
  }, [_c('img', {
    attrs: {
      "width": "20",
      "src": _vm.usuario.image,
      "alt": _vm.usuario.nome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nome",
    class: {
      'font-bold': _vm.isCurrentUser || _vm.usuario.naoLidas > 0
    }
  }, [(_vm.usuario.naoLidas > 0) ? _c('span', {
    staticClass: "badge badge-sm bg-danger pull-right-xs"
  }, [_vm._v(_vm._s(_vm.usuario.naoLidas))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.nomeChat) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("\n    " + _vm._s(_vm.ultimoAcesso) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a37b1282","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatUsuarioItem.vue
// module id = 1846
// module chunks = 17